import React from 'react'
import TypographyAtom from '../../atoms/typography/typography'
import { ImageFilter, ImageWrapper, ItemContainer } from './Accreditation.styled'
import { GatsbyImage } from 'gatsby-plugin-image'

function AccreditationItem({ image, title, subtitle }) {
  return (
    <ItemContainer className="flex">
      <ImageWrapper>
        <GatsbyImage image={image} alt={title} />
        <ImageFilter />
      </ImageWrapper>
      <div>
        <TypographyAtom type="P" weight="Bold" copy={title} />

        <TypographyAtom
          className="item-subtitle"
          type="P"
          weight="Regular"
          copy={subtitle}
          color="Grey"
        />
      </div>
    </ItemContainer>
  )
}

export default AccreditationItem
